<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>

    <v-container fluid>
      <v-row class="mb-4 mx-1">
        <v-col cols="6">
          <div class="d-flex flex-row">
            <h2 class="mb-2 mr-4">
              {{ $t("Ingredient Inventory") }}
            </h2>
            <!-- <v-btn
              outlined
              class="ml-4"
              right
              color="primary"
              style="background-color: white"
              @click="viewInventoryInfo()"
              v-if="!showInventoryInfoTemplate"
            >
              View Farm Info
            </v-btn>
            <template v-if="showInventoryInfoTemplate">
              <h4 class="mx-6 my-2 primary--text">#AIM23320</h4>
              <v-btn
                outlined
                color="primary"
                style="background-color: white"
                @click="showInventoryInfoTemplate = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template> -->
          </div>
        </v-col>
        <template v-if="showInventoryInfoTemplate">
          <v-col cols="6"> </v-col>
          <v-col cols="12">
            <v-card class="elevation-0">
              <v-card-text>
                <v-row>
                  <v-col cols="">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            Farm Type
                          </v-list-item-subtitle>
                          <v-list-item-title class="text-h6 mt-2">
                            {{ this.primaryFarm.farmType }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-divider vertical inset></v-divider>
                  <v-col cols="">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            Farm Owner
                          </v-list-item-subtitle>
                          <v-list-item-title
                            class="text-h6 mt-2 text-capitalize"
                          >
                            {{ this.primaryFarm.farmOwner }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-divider vertical inset></v-divider>
                  <v-col cols="">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            Govt Registry #
                          </v-list-item-subtitle>
                          <v-list-item-title
                            class="text-h6 mt-2 text-capitalize"
                          >
                            #{{ this.primaryFarm.govRegistrationNum }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-divider vertical inset></v-divider>
                  <v-col cols="">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            Cooperative ID
                          </v-list-item-subtitle>
                          <v-list-item-title
                            class="text-h6 mt-2 text-capitalize"
                          >
                            #{{ this.primaryFarm.cooperativeId }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-divider vertical inset></v-divider>
                  <v-col cols="">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            Date Of Registration
                          </v-list-item-subtitle>
                          <v-list-item-title
                            class="text-h6 mt-2 text-capitalize"
                          >
                            {{ this.primaryFarm.createdAt }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6"> </v-col>
        </template>
        <v-col cols="6">
          <div class="text-right">
            <v-btn
              v-if="selected.length < 1"
              class="mr-4 px-5"
              right
              depressed
              color="primary"
              @click="$router.push({ name: 'AddNewIngredient' })"
            >
              add new ingredient
            </v-btn>
            <v-btn
              class="px-5"
              right
              depressed
              color="primary"
              dense
              @click="createOrder()"
            >
              create order
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-card elevation="0" class="mx-4">
        <v-card-text>
          <v-data-table
            :headers="this.tableHeaders"
            :items="getIngredients"
            :header-props="{
              'sort-icon': 'mdi-unfold-more-horizontal',
            }"
            :loading="$apollo.loading"
            v-model="selected"
            show-select
            :items-per-page="itemsPerPage"
            :hide-default-footer="true"
            :options.sync="tableOptions"
            class="ma-3"
            loading-text="Loading Ingredients... Please wait"
          >
            <template v-slot:top>
              <div class="d-flex">
                <v-text-field
                  :hide-details="true"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  placeholder="Search by name"
                  dense
                  v-model="search"
                  @click:append="searchIngredientInventory"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>

                <!-- <v-select
                  :hide-details="true"
                  :items="status"
                  rounded
                  outlined
                  dense
                  placeholder="All"
                  class="shrink"
                  style="width: 200px; margin-left: 10px;"
                ></v-select> -->
                <v-spacer></v-spacer>
                <div class="py-3">
                  {{ from }} - {{ to }} of {{ totalIngredients }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  left
                  :min-width="417"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      fab
                      small
                      outlined
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> mdi-cog-outline</v-icon>
                    </v-btn>
                  </template>

                  <v-card width="417">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            $t("customization")
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <div class="pl-3 pt-2 font-weight-normal">
                        {{ $t("recordsPerPage") }}
                      </div>
                      <v-list-item>
                        <v-list-item-content>
                          <v-slider
                            v-model="itemsPerPageSlider"
                            :tick-labels="itemsPerPageOptions"
                            :max="3"
                            step="1"
                            ticks="always"
                            tick-size="4"
                          ></v-slider>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-n3"></v-divider>
                    </v-list>
                    <v-card-text>
                      <v-container fluid>
                        <v-row>
                          <v-col
                            class="mt-n9"
                            cols="6"
                            v-for="header in headers"
                            :key="header.value"
                          >
                            <v-checkbox
                              v-if="header.text.length > 0"
                              v-model="selectedHeaders"
                              :label="header.text"
                              color="primary"
                              :value="header.text"
                              hide-details
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-layout justify-center>
                      <v-card-actions class="mb-5">
                        <v-spacer></v-spacer>

                        <v-btn
                          outlined
                          color="primary"
                          width="190"
                          @click="resetDefault"
                        >
                          {{ $t("restoreDefault") }}
                        </v-btn>
                        <v-btn color="primary" @click="resetTableStructure">
                          {{ $t("apply") }}
                        </v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-menu>
              </div>
              <div class="my-4" style="float: left">
                <span v-if="selected.length === 1">
                  <v-btn
                    @click="editOrderWithIngredient(selected[0].id)"
                    class="px-5"
                    color="primary"
                    depressed
                    >Update Order</v-btn
                  >
                  <v-btn
                    @click="editIngredient(selected[0].id)"
                    color="primary"
                    class="px-5 mx-4"
                    depressed
                    >Edit</v-btn
                  >
                </span>
              </div>
              <div class="my-4" style="float: right">
                <span v-if="selected.length">
                  <v-btn
                    class="px-5"
                    outlined
                    color="primary"
                    @click="removeIngredientDialog(selected)"
                    >Bulk Delete</v-btn
                  >
                </span>
              </div>
              <div style="clear: both"></div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="6"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:item.name="{ item }">
              <span
                style="cursor: pointer"
                class="text-decoration-underline"
                @click="viewIngredientInfo(item.id)"
              >
                {{ item.name }}
              </span>
            </template>
            <template v-slot:item.cost="{ item }">
              <span> {{ item.currencyId }} {{ item.price }} </span>
            </template>
            <template v-slot:item.stock="{ item }">
              <span> {{ item.totalStock }}{{ item.unit.abbr }} </span>
            </template>
            <template v-slot:item.supplier="{ item }">
              <span>
                {{ item.authentication?.firstName }}
                {{ item.authentication?.lastName }}
              </span>
            </template>
            <template v-slot:item.expiryDate="{ item }">
              <span>
                {{ item.expiryDate ? item.expiryDate : "" | formatDate }}
              </span>
            </template>
            <template v-slot:item.status="{ item }">
              <v-btn
                outlined
                rounded
                small
                depressed
                :class="getStockStatus(item.totalStock).className"
              >
                {{ getStockStatus(item.totalStock).status }}
                <!-- {{item.totalStock}} -->
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <remove-ingredient-dialog
      v-if="showRemoveIngredientDialog"
      :dialogI="showRemoveIngredientDialog"
      :ingredientsIdArr="this.ingredientsIdArr"
      :ingredientName="this.ingredientName"
      @closeDialog="showRemoveIngredientDialog = false"
      @removeIngredientSuccess="removedIngredient"
    ></remove-ingredient-dialog>
    <create-order-dialog
      v-if="showCreateOrderDialog"
      :dialogI="showCreateOrderDialog"
      @closeDialog="showCreateOrderDialog = false"
      @orderCreated="OrderCreatedSuccess"
    ></create-order-dialog>
    <edit-order-dialog
      v-if="showEditOrderDialog"
      :dialogI="showEditOrderDialog"
      :ingredientId="ingredientId"
      @closeDialog="showEditOrderDialog = false"
      @orderUpdated="OrderCreatedSuccess"
    ></edit-order-dialog>
    <ingredient-info-dialog
      v-if="showIngredientInfoDialog"
      :dialogI="showIngredientInfoDialog"
      :ingredientId="ingredientId"
      @closeDialog="showIngredientInfoDialog = false"
      @removeIngredient="removeIngredientDialog"
    ></ingredient-info-dialog>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";
// import FarmService from "@/_services/farmService";
import RemoveIngredientDialog from "./RemoveIngredientDialog.vue";
import IngredientInfoDialog from "./IngredientInfoDialog.vue";
import CreateOrderDialog from "./CreateOrderDialog.vue";
import EditOrderDialog from "./EditOrderDialog.vue";

export default {
  apollo: {
    getIngredients: {
      query: gql`
        query getIngredients($queryData: GetQueryDataArgs!) {
          getIngredients(queryData: $queryData) {
            rows {
              id
              name
              currencyId
              price
              converted_usd_price
              totalStock
              unitId
              suppliers
              expiryDate
              unit {
                name
                abbr
              }
              authentication {
                firstName
                lastName
              }
            }
            count
            totalCount
          }
        }
      `,
      fetchPolicy: "no-cache",
      variables() {
        return {
          queryData: {
            page: this.tableOptions.page,
            limit: this.tableOptions.itemsPerPage,
            searchPhrase: this.search,
          },
          // farmId: parseInt(this.$store.state.farm.farm.id),
        };
      },
      update: data => data.getIngredients.rows,
      result({ data }) {
        this.totalIngredients = data.getIngredients.totalCount;
        this.totalPages = Math.ceil(
          this.totalIngredients / this.tableOptions.itemsPerPage
        );
        this.from =
          (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
        this.to =
          this.tableOptions.page * this.tableOptions.itemsPerPage -
          (this.tableOptions.itemsPerPage - data.getIngredients.count);
      },
    },
  },
  components: {
    "remove-ingredient-dialog": RemoveIngredientDialog,
    "create-order-dialog": CreateOrderDialog,
    "ingredient-info-dialog": IngredientInfoDialog,
    "edit-order-dialog": EditOrderDialog,
  },

  async mounted() {
    document.title = this.$t("Ingredient Inventory");
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;

    this.startLoading();

    // this.farmId = this.$store.state.farm.farm.id;

    // if (this.farmId == null) {
    //   this.$router.push("/myfarm");
    // }

    // this.farmId = parseInt(localStorage.getItem('farmID'));

    // const {data} = await FarmService.getPrimaryFarm();
    // if(_.isEmpty(data)){
    // 	return;
    // }
    this.primaryFarm = this.$store.state.farm.farm;
    setTimeout(() => {
      this.stopLoading();
    }, 2000);
  },
  data() {
    return {
      ingredientId: null,
      ingredientsIdArr: [],
      ingredientName: null,
      showRemoveIngredientDialog: false,
      showCreateOrderDialog: false,
      showEditOrderDialog: false,
      showInventoryInfoTemplate: false,
      showIngredientInfoDialog: false,
      loading: true,
      breadcrumbs: [
        {
          text: this.$t("dashbaord"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("Feed Management"),
          disabled: true,
          to: { name: "Feed Management" },
        },
        {
          text: this.$t("Ingredient Inventory"),
          disabled: true,
          to: "/ingredient-inventory",
        },
      ],
      farmId: null,
      primaryFarm: {},
      tab: null,

      menu: false,
      itemsPerPage: 10,
      itemsPerPageSlider: 0,
      itemsPerPageOptions: [5, 10, 25, 50],
      to: 0,
      from: 0,
      totalPages: "",
      totalIngredients: "",
      transition: true,
      pageCount: 1,
      currentrows: 0,
      search: "",
      selected: [],
      items: [],
      selectedItem: false,
      tableOptions: { itemsPerPage: 10, page: 1 },
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      allSelectedHeaders: [
        "Feed Ingredients Name",
        "Cost Per Unit",
        "Stock Volume",
        "Supplier Name",
        "Current Expiry Date",
        "Stock Status",
      ],
      tableHeaders: [],
      headers: [
        {
          align: "start",
          text: "Feed Ingredients Name",
          value: "name",
          class: "black--text",
          sortable: true,
        },
        {
          text: "Cost Per Unit",
          value: "cost",
          class: "black--text",
          sortable: true,
        },
        {
          text: "Stock Volume",
          value: "stock",
          class: "black--text",
          sortable: true,
        },
        {
          text: "Supplier Name",
          value: "supplier",
          class: "black--text",
          sortable: true,
        },
        {
          text: "Current Expiry Date",
          value: "expiryDate",
          class: "black--text",
          sortable: true,
        },
        {
          text: "Stock Status",
          value: "status",
          class: "black--text",
          sortable: false,
        },
      ],
      selectedHeaders: [],

      getIngredients: [],
      totalCount: 5,
      showRequestSatelliteReportDialog: false,
      existingLocationDialog: false,
      confirmationDialog: true,
    };
  },
  watch: {
    tableOptions: {
      handler() {
        this.$apollo.queries.getIngredients.refetch();
      },
      deep: true,
    },
  },
  methods: {
    removeIngredientDialog(selected) {
      this.ingredientsIdArr = selected.map(select => parseInt(select.id));
      if (this.ingredientsIdArr.length === 1) {
        this.ingredientName = selected[0].name;
      } else {
        this.ingredientName = "selected ingredients";
      }

      this.showRemoveIngredientDialog = true;
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;
      this.$apollo.queries.getIngredients.refetch();
    },
    createOrder() {
      this.showCreateOrderDialog = true;
    },
    viewInventoryInfo() {
      this.showInventoryInfoTemplate = true;
    },
    viewIngredientInfo(id) {
      this.ingredientId = parseInt(id);
      this.showIngredientInfoDialog = true;
    },
    searchUsers() {
      this.tableOptions.page = 1;
      // this.getIngredients()
    },
    resetSearchOnEmpty() {
      if (this.search != "") return;
      this.tableOptions.page = 1;
      // this.getIngredients()
    },
    searchIngredientInventory() {},

    resetTableStructure() {
      this.startLoading();
      this.tableHeaders = this.headers.filter(header =>
        this.selectedHeaders.includes(header.text.toString())
      );

      this.tableOptions.itemsPerPage =
        this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      this.stopLoading();
    },

    resetDefault() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
    },

    editOrderWithIngredient(ingredientID) {
      this.ingredientId = parseInt(ingredientID);
      this.showEditOrderDialog = true;
    },

    editIngredient(ingredientID) {
      this.$router.push({
        path: `/feed-management/ingredient-inventory/${ingredientID}/edit`,
      });
    },

    searchIngredient() {
      this.startLoading();
      if (this.search == "") return;
      else {
        this.tableOptions.page = 1;
        this.$apollo.queries.getIngredients.refetch();
      }
      this.stopLoading();
    },

    OrderCreatedSuccess() {
      this.selected = [];
      console.log("success");
      this.$apollo.queries.getIngredients.refetch();
    },

    removedIngredient() {
      this.selected = [];
      this.showRemoveIngredientDialog = false;
      this.$apollo.queries.getIngredients.refetch();
    },
    getStockStatus(stockValue) {
      let resultData = {
        status: "",
        className: "",
      };

      if (stockValue >= 100) {
        resultData = {
          status: "In Stock",
          className: "instock_status",
        };
      } else if (stockValue < 100 && stockValue >= 50) {
        resultData = {
          status: "Low Stock",
          className: "lowstock_status",
        };
      } else if (stockValue < 50 && stockValue >= 1) {
        resultData = {
          status: "Critically Low",
          className: "criticallylow_status",
        };
      } else {
        resultData = {
          status: "Out of Stock",
          className: "outofstock_status",
        };
      }
      return resultData;
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
.border {
  border: 2px solid;
  border-color: #dae1ec;
}

.v-tab {
  text-transform: none !important;
}

.instock_status {
  color: #00bd73;
  background: #e5f8f1;
}

.lowstock_status {
  color: #1e1e1e;
  background: #e8e8e8;
}

.criticallylow_status {
  color: #ffb443;
  background: #fff0d9;
}

.outofstock_status {
  color: #f03737;
  background: #fdebeb;
}
</style>
